import { createSlice, PayloadAction } from '@reduxjs/toolkit';
import { Municipality } from '../interface/Municipality';

interface MunicipalityState {
  selectedMunicipality: Municipality | null;
}

const initialState: MunicipalityState = {
  selectedMunicipality: null,
};

const municipalitySlice = createSlice({
  name: 'municipality',
  initialState,
  reducers: {
    setMunicipality(state, action: PayloadAction<Municipality>) {
      state.selectedMunicipality = action.payload;
    },
    clearMunicipality(state) {
      state.selectedMunicipality = null;
    },
    updateMunicipality(state, action: PayloadAction<Partial<Municipality>>) {
      if (state.selectedMunicipality) {
        state.selectedMunicipality = {
          ...state.selectedMunicipality,
          ...action.payload,
        };
      }
    },
  },
});

export const { setMunicipality, clearMunicipality, updateMunicipality } =
  municipalitySlice.actions;

export default municipalitySlice.reducer;
